import { useState } from "react";

import SignInForm from "../../components/forms/SignInForm";
import Main from "../../components/layout/Main";
import MetaData from "../../components/MetaData";

const SEO_TITLE = "Inloggen";

const SignIn = () => {
  const [disabled, setDisabled] = useState(false);
  const handleSuccess = () => {
    window.location.reload();
    setDisabled(true);
  };

  return (
    <Main>
      <MetaData title={SEO_TITLE} />
      <SignInForm disabled={disabled} onSuccess={handleSuccess} />
    </Main>
  );
};

export default SignIn;
